import { Card } from '@verclam/ui-kit';
import type * as React from 'react';

const formSectionPt: React.ComponentProps<typeof Card>['pt'] = {
	body: {
		style: {
			display: 'flex',
			flexDirection: 'column',
			padding: '0',
		},
	},
	title: {
		style: {
			marginTop: '.75rem',
			paddingLeft: '.75rem',
		},
	},
	content: {
		style: {
			display: 'flex',
			flexDirection: 'column',
			padding: '.75rem 0 0 0',
		},
	},
};

type Props = {
	readonly title: string;
	readonly children: React.ReactNode;
};

/**
 * Uses `Card` as a form section rather than a standalone tile: the `pt` neutralizes the padding
 * `Card` applies to `body`, `title` and `content` so the fields fill the section edge to edge.
 */
const FormSection: React.FC<Props> = ({ title, children }) => {
	return (
		<Card title={title} pt={formSectionPt}>
			{children}
		</Card>
	);
};

export default FormSection;
